module.exports = __webpack_public_path__ + "media/images/flags/GB-ZET-ba5e0fd8d5341b259a6e5f93db55a008.svg";